import styled from "styled-components/macro";

export const Paper = styled.div`
  min-width: ${(props) =>
    props.size === "s" ? "400px" : props.size === "m" ? "720px" : props.size === "l" ? "1190px" : "unset"};
  max-width: ${(props) =>
    props.size === "s" ? "400px" : props.size === "m" ? "720px" : props.size === "l" ? "1190px" : "unset"};
  max-height: 90vh;
  overflow: auto;
  background-color: #fff;
  border-radius: 0.5em;
  outline: none;
  @media (max-width: 1225px) {
    min-width: 90%;
  }
`;

export const CloseButton = styled.button`
  width: 2em;
  height: 2em;
  border-radius: 0.25em;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    background: #eee;
  }

  &:disabled {
    opacity: 0.5;
  }
`;


export const Title = styled.h3`
margin: 0;
background: #f5fafe;
font-size: 1.25em;
text-align: center;
text-transform: capitalize;
`;
export const Description = styled.h3`
font-size: 1em;
color: #b6b6b7;
text-align: center;
`;